import {createEntityService} from 'utils/createEntityService';
import {Client} from 'types/client';
import apiClient from './apiClient';

export const BaseClientService = createEntityService<Client>({
  baseUrl: 'api/v1/clients',
  entityName: 'client',
  methodConfigs: {
    create: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
    update: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  },
});

export class ClientService extends BaseClientService {
}
